import { render, staticRenderFns } from "./RewardCard.vue?vue&type=template&id=cbd9e3c8&scoped=true"
import script from "./RewardCard.vue?vue&type=script&lang=js"
export * from "./RewardCard.vue?vue&type=script&lang=js"
import style0 from "./RewardCard.vue?vue&type=style&index=0&id=cbd9e3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd9e3c8",
  null
  
)

export default component.exports